import type { State } from "@App/state";

export const selectDesiredReturnDates = (state: State) => ({
  date1: state.vehicleReturnPickup.desiredReturnDates.date1
    ? new Date(state.vehicleReturnPickup.desiredReturnDates.date1)
    : null,
  date2: state.vehicleReturnPickup.desiredReturnDates.date2
    ? new Date(state.vehicleReturnPickup.desiredReturnDates.date2)
    : null,
  date3: state.vehicleReturnPickup.desiredReturnDates.date3
    ? new Date(state.vehicleReturnPickup.desiredReturnDates.date3)
    : null,
});

export const selectPickUpAddress = (state: State) => state.vehicleReturnPickup.pickUpAddress;

export const selectContractDetails = (state: State) => state.vehicleReturnPickup.contractDetails;

export const selectIsAuthenticated = (state: State) => state.vehicleReturnPickup.isAuthenticated;
